function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
  return _classApplyDescriptorGet(receiver, descriptor);
}
function _classPrivateFieldSet(receiver, privateMap, value) {
  var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
  _classApplyDescriptorSet(receiver, descriptor, value);
  return value;
}
function _classExtractFieldDescriptor(receiver, privateMap, action) {
  if (!privateMap.has(receiver)) {
    throw new TypeError("attempted to " + action + " private field on non-instance");
  }
  return privateMap.get(receiver);
}
function _classApplyDescriptorGet(receiver, descriptor) {
  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }
  return descriptor.value;
}
function _classApplyDescriptorSet(receiver, descriptor, value) {
  if (descriptor.set) {
    descriptor.set.call(receiver, value);
  } else {
    if (!descriptor.writable) {
      throw new TypeError("attempted to set read only private field");
    }
    descriptor.value = value;
  }
}
function _classPrivateMethodGet(receiver, privateSet, fn) {
  if (!privateSet.has(receiver)) {
    throw new TypeError("attempted to get private field on non-instance");
  }
  return fn;
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _classPrivateMethodInitSpec(obj, privateSet) {
  _checkPrivateRedeclaration(obj, privateSet);
  privateSet.add(obj);
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".scroll-zoom-clamp-message {\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  color: white;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 17px;\n  pointer-events: none;\n}";
styleInject(css_248z);

var _showMsg = /*#__PURE__*/new WeakSet();
var _node = /*#__PURE__*/new WeakMap();
var _msgNode = /*#__PURE__*/new WeakMap();
var _msgTimeout = /*#__PURE__*/new WeakMap();
var ScrollZoomClamp = /*#__PURE__*/function () {
  function ScrollZoomClamp(childNode) {
    var _this = this,
      _window,
      _window2;
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      message = _ref.message;
    _classCallCheck(this, ScrollZoomClamp);
    _classPrivateMethodInitSpec(this, _showMsg);
    _classPrivateFieldInitSpec(this, _node, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _msgNode, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _msgTimeout, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldSet(this, _node, document.createElement('div'));
    _classPrivateFieldGet(this, _node).style.position = 'relative';
    _classPrivateFieldGet(this, _node).addEventListener('wheel', function (e) {
      if (!e.metaKey && !e.ctrlKey) {
        e.stopPropagation();
        _classPrivateMethodGet(_this, _showMsg, _showMsg2).call(_this, true);
      } else {
        e.preventDefault();
        _classPrivateMethodGet(_this, _showMsg, _showMsg2).call(_this, false);
      }
    }, true);
    var keyChar = (_window = window) !== null && _window !== void 0 && (_window = _window.navigator) !== null && _window !== void 0 && (_window = _window.platform) !== null && _window !== void 0 && _window.startsWith('Mac') ? '&#x2318' : (_window2 = window) !== null && _window2 !== void 0 && (_window2 = _window2.navigator) !== null && _window2 !== void 0 && (_window2 = _window2.platform) !== null && _window2 !== void 0 && _window2.startsWith('Win') ? '&#x229E' : 'ctrl';
    _classPrivateFieldSet(this, _msgNode, document.createElement('div'));
    _classPrivateFieldGet(this, _msgNode).classList.add('scroll-zoom-clamp-message');
    _classPrivateFieldGet(this, _msgNode).style.opacity = 0;
    _classPrivateFieldGet(this, _msgNode).innerHTML = message || "Use&nbsp;<b>".concat(keyChar, "</b>&nbsp;+&nbsp;<b>scroll</b>&nbsp;to zoom the chart");
    _classPrivateFieldGet(this, _node).appendChild(childNode);
    _classPrivateFieldGet(this, _node).appendChild(_classPrivateFieldGet(this, _msgNode));
  }
  _createClass(ScrollZoomClamp, [{
    key: "node",
    get: function get() {
      return _classPrivateFieldGet(this, _node);
    }
  }]);
  return ScrollZoomClamp;
}();
function _showMsg2() {
  var _this2 = this;
  var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  _classPrivateFieldGet(this, _msgNode).style.transition = "opacity ".concat(show ? 0 : 1000, "ms");
  _classPrivateFieldGet(this, _msgNode).style.opacity = show ? '1' : '0';
  clearTimeout(_classPrivateFieldGet(this, _msgTimeout));
  show && _classPrivateFieldSet(this, _msgTimeout, setTimeout(function () {
    return _classPrivateMethodGet(_this2, _showMsg, _showMsg2).call(_this2, false);
  }, 1000));
}

export { ScrollZoomClamp as default };
